import React from 'react';
import { Link } from "react-router-dom"; 
import { useTranslation } from 'react-i18next';
import './NewsCards.css';
import { newsData } from './NewsData';

const NewsCards = ({ limit }) => {
  const { t } = useTranslation();
  const data = newsData(t);
  
  // Get only the latest news items (first 3 or specified limit)
  const reversedNews = [...data].reverse(); // Create a copy and reverse
  const latestNews = limit ? reversedNews.slice(0, limit) : reversedNews;

  const handleScrollToNews = (id) => {
    setTimeout(() => {
      const element = document.getElementById(`news-${id}`);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };

  return (
    <div className="news-page" id="main">
      <div className="card-list">
        {latestNews.map(news => (
           <Link 
            to={`/news#news-${news.id}`} 
            key={news.id}
            onClick={() => handleScrollToNews(news.id)}
            className="news-card-link-wrapper"
          >
            <div className="card-link-wrapper" >
              <img src={news.image} alt={news.title} className="card-image" />
              <div className="card-content">
                <h3 className="card-title">{news.title}</h3>
                <p className="card-date">{news.date}</p>
                <p className="card-description">{news.excerpt}</p>
                <div className="card-link">
                  {t('news.read_more')}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NewsCards;